(ns app.front.view.admin.excise.common
  (:require [app.front.entities :as entities]
            [core.front.carbon :as cc]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::candidates
  :-> ::candidates)

(rf/reg-sub ::types
  :<- [::candidates]
  :-> keys)

(rf/reg-sub ::state
  :-> ::state)

(rf/reg-sub ::selected-type
  :<- [::state]
  :<- [::types]
  (fn [[state types] _]
    (or (:selected-type state)
        (first types))))

(rf/reg-event-db ::select-type
  (fn [db [_ type]]
    (assoc-in db [::state :selected-type] type)))

(rf/reg-sub ::selectable-candidates
  :<- [::selected-type]
  :<- [::candidates]
  :<- [::entities/context]
  (fn [[type candidates ctx] _]
    (->> type
         (get candidates)
         (map (partial entities/find-entity ctx))
         (sort-by :db/id))))

(def section :section.p-4.my-4)

(defn help []
  [:div.max-w-2xl.ml-4
   [:p "Excise removes data " [:span.font-bold "permanently"] " from the database."]
   [:p
    "It should be used only to remove sensitive data, such as Personally Identifiable Information "
    "that is no longer needed nor used and therefore needs to be removed for legal reasons."]
   [:p
    "It is strongly recommended to " [:span.font-bold "back up the database"] " before excising any data. "
    "That must be done by a member of the development team on the cloud console. "
    "Excising large amounts of data may negatively affect performance, so it is recommended to only "
    "be done on off-peak hours."]])

(defn page [content]
  [:div
   [:h1.mb-4 "Excise data"]
   [section {:class "flex items-center"}
    (cc/icon {:icon        i/warning
              :height      "75px"
              :width       "75px"
              :description "Important information"})
    [help]]
   content])

(defmulti data-select (fn [type] type))
(defmethod data-select :default [_ _]
  (cc/loading-spinner {:with-overlay false}))
